module.exports = __webpack_public_path__ + "static/media/24UHCHR4.a7055f87.jpg";